module.exports = __webpack_public_path__ + "img/img_box3.b7d3a569.png";